import {
  EMAIL_TEMPLATE_REQUEST,
  EMAIL_TEMPLATE_SUCCESS,
  EMAIL_TEMPLATE_FAILURE,
  EMAIL_TEMPLATE_UPDATE_SUCCESS,
  EDIT_MODULE_TOGGLE_HTML,
  EDIT_MODULE_TOGGLE_CSS,
  EDIT_MODULE_TOGGLE_DATA,
  EDIT_MODULE_TOGGLE_PREVIEW,
  EMAIL_TEMPLATE_SET_KEY_VALUE,
  EMAIL_TEMPLATE_UPDATE_NAME_VALUE,
} from "../constants/ActionTypes";

const initialState = {
  display: "desktop",
  unsavedChanges: false,

  showHtml: true,
  showCss: true,
  showData: true,
  showPreview: false,

  emailTemplate: {
    template: "xyx",
  },
};

export default function emailTemplateEditor(state = initialState, action) {
  switch (action.type) {
    case EMAIL_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        unsavedChanges: false,
        emailTemplate: {},
      });

    case EMAIL_TEMPLATE_FAILURE:
      return Object.assign({}, state, {
        emailTemplate: {
          failed: true,
        },
      });

    case EMAIL_TEMPLATE_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: false,
        emailTemplate: action.data,
      });

    case EMAIL_TEMPLATE_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: false,
      });

    case EDIT_MODULE_TOGGLE_HTML:
      return Object.assign({}, state, {
        showHtml: !state.showHtml,
      });

    case EDIT_MODULE_TOGGLE_CSS:
      return Object.assign({}, state, {
        showCss: !state.showCss,
      });

    case EDIT_MODULE_TOGGLE_DATA:
      return Object.assign({}, state, {
        showData: !state.showData,
      });

    case EDIT_MODULE_TOGGLE_PREVIEW:
      return Object.assign({}, state, {
        showPreview: !state.showPreview,
      });

    case EMAIL_TEMPLATE_SET_KEY_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        emailTemplate: Object.assign({}, state.emailTemplate, {
          [action.key]: action.value,
        }),
      });

    case EMAIL_TEMPLATE_UPDATE_NAME_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        emailTemplate: Object.assign({}, state.emailTemplate, {
          name: action.value,
        }),
      });
  }

  return state;
}
